"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBonusBalance = void 0;
var useBalance_1 = require("./useBalance");
var react_1 = require("react");
var useBonusBalance = function () {
    var balance = (0, useBalance_1.useBalance)().data;
    return (0, react_1.useMemo)(function () {
        if (!balance)
            return null;
        return (Number(balance.totalAmount) || 0) - (Number(balance.amount) || 0);
    }, [balance]);
};
exports.useBonusBalance = useBonusBalance;
